'use client'

import { AnalyticsProvider } from '@/components/provider/analytics-provider'
import { GlobalSearchProvider } from '@/components/provider/global-search-provider'
import { getStoryblokApi } from '@/lib/storyblok'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { isServer, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ReactQueryStreamedHydration } from '@tanstack/react-query-next-experimental'
import { PropsWithChildren } from 'react'

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  })
}

let browserQueryClient: QueryClient | undefined = undefined

function getQueryClient() {
  if (isServer) {
    return makeQueryClient()
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient()
    return browserQueryClient
  }
}

export function Providers({ children }: PropsWithChildren) {
  getStoryblokApi()
  const queryClient = getQueryClient()
  const domain = process.env.NEXT_PUBLIC_DOMAIN || process.env.NEXT_PUBLIC_VERCEL_URL

  return (
    <AnalyticsProvider domain={domain}>
      <QueryClientProvider client={queryClient}>
        <GoogleOAuthProvider clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}>
          <ReactQueryStreamedHydration>
            <GlobalSearchProvider>{children}</GlobalSearchProvider>
          </ReactQueryStreamedHydration>
          <ReactQueryDevtools initialIsOpen={false} />
        </GoogleOAuthProvider>
      </QueryClientProvider>
    </AnalyticsProvider>
  )
}
